/**
 * Lokalizácia PrimeReact Calendar – zdieľané ServiceTaskDetail / CRM detaily.
 */
export function buildPrimeReactCalendarLocale(calLocale, t) {
  const monthLongFmt = new Intl.DateTimeFormat(calLocale, { month: 'long', timeZone: 'UTC' });
  const monthShortFmt = new Intl.DateTimeFormat(calLocale, { month: 'short', timeZone: 'UTC' });
  const wdLongFmt = new Intl.DateTimeFormat(calLocale, { weekday: 'long', timeZone: 'UTC' });
  const wdShortFmt = new Intl.DateTimeFormat(calLocale, { weekday: 'short', timeZone: 'UTC' });
  const wdNarrowFmt = new Intl.DateTimeFormat(calLocale, { weekday: 'narrow', timeZone: 'UTC' });
  const sundayUtc = new Date(Date.UTC(2000, 0, 2));
  const dayNames = [];
  const dayNamesShort = [];
  const dayNamesMin = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(sundayUtc);
    d.setUTCDate(sundayUtc.getUTCDate() + i);
    dayNames.push(wdLongFmt.format(d));
    dayNamesShort.push(wdShortFmt.format(d));
    dayNamesMin.push(wdNarrowFmt.format(d));
  }
  const monthNames = [];
  const monthNamesShort = [];
  for (let m = 0; m < 12; m++) {
    const d = new Date(Date.UTC(2000, m, 1));
    monthNames.push(monthLongFmt.format(d));
    monthNamesShort.push(monthShortFmt.format(d));
  }
  return {
    firstDayOfWeek: 1,
    dayNames,
    dayNamesShort,
    dayNamesMin,
    monthNames,
    monthNamesShort,
    today: t('Common.Today'),
    clear: t('Common.Clear'),
    chooseDate: t('Common.ChooseDate'),
  };
}

export const CRM_CALENDAR_INPUT_STYLE = {
  border: '1px solid #e5e7eb',
  transition: 'background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s',
  borderRadius: '6px',
};
